import * as React from "react";
import { Heading } from "@grandvisionhq/elements";
import { Spinner, Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { useGetWishlist } from "../../../../../../hooks/hooks/use-get-wishlist.js";
import { usePageViewAccountWishlistEvent } from "../../../../hooks/modules/overview/hooks/use-pageview-account-wishlist-event.js";
import Wishlist from "./Wishlist.js";
/* empty css                      */
const AnonymousWishlist = ({
  isMyAccountEnabled,
  isUpdateLoading,
  isAuthLoading,
  onUpdateWishList
}) => {
  const { getFormattedLabel, getLabel } = useIntl();
  const { data, loading, error } = useGetWishlist();
  usePageViewAccountWishlistEvent(data, loading);
  const labels = {
    introFull: getLabel("account.wishlist.intro.full"),
    login: getFormattedLabel("account.wishlist.login", {
      parseLink: true
    })
  };
  const onRemoveWishlistItem = (sku) => {
    onUpdateWishList(sku, data?.id);
  };
  return /* @__PURE__ */ React.createElement("div", { className: "wishlist-overview" }, /* @__PURE__ */ React.createElement(Heading, { variant: "small", component: "h1" }, getLabel("account.wishlist")), loading || isAuthLoading ? /* @__PURE__ */ React.createElement(Spinner, { "aria-label": getLabel("common.loadingText") }) : error ? /* @__PURE__ */ React.createElement(Alert, { variant: "error", className: "alert-m-default" }, getLabel("account.wishlist.error")) : /* @__PURE__ */ React.createElement(
    Wishlist,
    {
      wishlistLabels: labels,
      items: data?.items,
      onUpdateWishList: onRemoveWishlistItem,
      isUpdateLoading,
      isMyAccountEnabled
    }
  ));
};
export {
  AnonymousWishlist as default
};
//# sourceMappingURL=AnonymousWishlistOverview.js.map
